/*
 * File: debounce.ts
 * File Created: 2023-12-20 04:34:06
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2023-12-20 05:49:08
 * Modified By: Val Liu
 * -----
 */

/// A debounced function delays executing until after a wait period
/// has elapsed since the last call.
/// If new calls are made during the wait period, the timer is reset.
export function debounce(delay: number) {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        const timerKey = Symbol(`_debounceTimer_${propertyKey}`);

        descriptor.value = function (...args: any[]) {
            if (!this[timerKey]) {
                Object.defineProperty(this, timerKey, {
                    configurable: true,
                    enumerable: false,
                    writable: true,
                    value: undefined,
                });
            }

            clearTimeout(this[timerKey]);
            this[timerKey] = setTimeout(() => {
                originalMethod.apply(this, args);
            }, delay);
        };

        return descriptor;
    };
}
